import wixData from "wix-data";

export async function loadGifts() {
    const results = await wixData.query("giftslist")
        .eq('_publishStatus', "PUBLISHED")
        .include("giftProduct")
        .include("relatedProduct")
        .find();
    console.log("results", results);
    const gifts = results.items.map((gift) => {
        const giftProduct = gift.giftProduct ? {
            name: gift.giftProduct.name,
            productId: gift.giftProduct._id,
            description: typeof gift.giftProduct.description === 'string' ? gift.giftProduct.description : '',
            formattedPrice: gift.giftProduct.formattedPrice,
            formattedDiscountedPrice: gift.giftProduct.formattedDiscountedPrice,
            inStock: gift.giftProduct.inStock,
            mainMedia: gift.giftProduct.mainMedia,
            productOptions: gift.giftProduct.productOptions || [],
        } : null;

        const relatedProducts = gift.relatedProduct ? gift.relatedProduct.map((related) => ({
            name: related.name,
            productId: related._id,
            description: typeof related.description === 'string' ? related.description : '',
            price: related.price,
            inStock: related.inStock,
            mainMedia: related.mainMedia,
            productOptions: related.productOptions || [],
        })) : [];

        return {
            giftAmount: gift.amount,
            endDate: gift.endDate,
            giftTitle: gift.title,
            giftProduct,
            relatedProducts,
        };
    });

    return gifts;
}